const DropdownOption = ({value, children, onClick, className, isDisabled}) => {
    return <span onClick={onClick}      
        className={"text-gray-700 block px-4 py-2 text-sm " + className + (isDisabled ? " cursor-not-allowed" : "")}
        role="menuitem"
        tabIndex="-1"        
        data-value={value}
    >
        {children}
    </span>;
}
export default DropdownOption;